
import { useNavigate } from 'react-router';


import { Lead, Place } from 'shared/topchef.types';
import PublicLeadContent from 'pages/shared/public-lead-content/PublicLeadContent';

export interface FollowedLeadDetailsFeesRejectedProps {
  loggedInPlace: Place,
  currentLead: Lead,
}

const FollowedLeadDetailsFeesRejected = (props: FollowedLeadDetailsFeesRejectedProps) => {

  console.log("je suis dans le FollowedLeadDetailsFeesRejected");

  const navigate = useNavigate();

  const backToFollowedLeads = async () => {
    navigate('/places/leads/followed');
  };

  return (
    <div className="container page-briefs-single-details p-2 col-md-6 overflow-auto">
      <div id="lead_sidebar" className="d-flex">
        <ul className="nav nav-pills flex-column mb-auto">
          <li className="nav-item"> <a href="/places/share-a-lead" type="button" className="btn btn-outline-primary nav-link add-brief-link">Ajouter un brief</a></li>
        </ul>
      </div>
       
      <PublicLeadContent publicLead={props.currentLead} />

      <div className="text-center">
        <div className="text-center btn-list">
          <button className="btn btn-primary m-3" onClick={backToFollowedLeads}>Retour aux briefs</button>
          <p>Loc'Hall s'occupe de ce brief pour vous.</p>
        </div>
      </div>
    </div>
  );

}


export default FollowedLeadDetailsFeesRejected;
